import { type EventOptions, getGlobalTracker, type ButtonClickedProps } from "@sparebank1/web-behavior-tracker";
import { getCookieValue } from "./trackingCookie";
import {
	epkProductId,
	fundAccount,
	hybridMedGarantiProductId,
	hybridMedInvesteringsvalg,
	innskuddtjenestepensjonMedGarantiProductId,
	ipsLoProductId,
	ipsProductId,
	ipsWithGarantiLoProductId,
	ipsWithGarantiProductId,
	itpMedInvesteringsvalg,
	loEpkProductId,
	loPbkProductId,
	pbgProductId,
	pensjonskontoLoProductId,
	pensjonskontoProductId,
} from "../policies";

export function getCustomData() {
	const abGroup = getCookieValue("AB");
	const abcGroup = getCookieValue("ABC");
	const bankTilhorighet = getCookieValue("AAC");
	const alder = getCookieValue("kundeAlder");
	const kjonn = getCookieValue("kundeKjonn");
	return { abGroup, abcGroup, bankTilhorighet, alder, kjonn };
}

export type AldersSegment = "U30" | "30-40" | "40-55" | "55-62" | "O62" | null;

export function getAldersSegment(alder: number): AldersSegment {
	if (alder < 30) return "U30";
	if (alder < 40) return "30-40";
	if (alder < 55) return "40-55";
	if (alder < 62) return "55-62";
	if (alder >= 62) return "O62";
	return null;
}

type Kjonn = "kvinne" | "mann" | null;
export function getKundeKjonn(ssn: string | number): Kjonn {
	const fnr = typeof ssn === "number" ? String(ssn).padStart(11, "0") : ssn;
	if (!/^\d{11}$/.test(fnr)) return null;
	return Number(fnr[8]) % 2 === 0 ? "kvinne" : "mann";
}

export function trackClick(properties: ButtonClickedProps, options?: EventOptions) {
	const { buttonClicked } = getGlobalTracker();
	const customData = getCustomData();
	buttonClicked(properties, { ...options, customData });
}

export function trackPage(options?: EventOptions) {
	const { page } = getGlobalTracker();
	const customData = getCustomData();
	page({ ...options, customData });
}

export function trackMultipleData(dataToTrack: (string | undefined)[], section: string, text: string) {
	dataToTrack.filter(Boolean).forEach((data) => {
		trackClick({ section: `${section}`, action: `${data}`, text });
	});
}

export function transformerTekst(tekst: string): string {
	return tekst
		.toLowerCase()
		.replace(/å/g, "a")
		.replace(/æ/g, "ae")
		.replace(/ø/g, "o")
		.replace(/[^a-z0-9\s_-]/g, "")
		.trim()
		.replace(/[\s_-]+/g, "-")
		.replace(/^-+|-+$/g, "")
		.slice(0, 100);
}

export function getProduktIdTrackNavn(id: string): string {
	switch (id) {
		case ipsProductId:
		case ipsLoProductId:
		case ipsWithGarantiProductId:
		case ipsWithGarantiLoProductId:
			return "ips";
		case pensjonskontoProductId:
		case pensjonskontoLoProductId:
			return "psk";
		case hybridMedInvesteringsvalg:
			return "hybrid-med-investeringsvalg";
		case pbgProductId:
			return "pensjonsbevis-med-garanti";
		case hybridMedGarantiProductId:
			return "hybrid-med-garanti";
		case itpMedInvesteringsvalg:
			return "itp-med-investeringsvalg";
		case innskuddtjenestepensjonMedGarantiProductId:
			return "itp-med-garanti";
		case epkProductId:
			return "epk";
		case loEpkProductId:
			return "epk-lo";
		case loPbkProductId:
			return "pkb-lo";
		case fundAccount:
			return "fondskonto";
		default:
			return id;
	}
}
